import { render, staticRenderFns } from "./TestIndex.vue?vue&type=template&id=0f6f751d&scoped=true&"
import script from "./TestIndex.vue?vue&type=script&lang=js&"
export * from "./TestIndex.vue?vue&type=script&lang=js&"
import style0 from "./TestIndex.vue?vue&type=style&index=0&id=0f6f751d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6f751d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f6f751d')) {
      api.createRecord('0f6f751d', component.options)
    } else {
      api.reload('0f6f751d', component.options)
    }
    module.hot.accept("./TestIndex.vue?vue&type=template&id=0f6f751d&scoped=true&", function () {
      api.rerender('0f6f751d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/test/TestIndex.vue"
export default component.exports